import React from 'react';
import ReactDOM from 'react-dom/client';
import { initWebPaymentTheme } from './webPaymentTheme';
import './theme.css';

initWebPaymentTheme();
import './i18n';
import App from './App';
import './App.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 